import React, { useState } from "react";
import VendorManagementTable from "./ManagementTable";
import { AnimatePresence } from "framer-motion";
import Form from "./AddVendorModal/Form";
import ManagementModal from "../../../../helperComponents/ManagementModal";
import ManagementControl from "../../../../helperComponents/ManagementControl";

const VendorManagement = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="relative z-10 h-[80%] bg-blue-grey w-full">
      <ManagementControl
        setShowModal={setShowModal}
        heading="Vendor Management"
        buttonText="vendor"
      />
      <VendorManagementTable />
      <AnimatePresence>
        {showModal && (
          <ManagementModal form>
            <Form setShowModal={setShowModal} />
          </ManagementModal>
        )}
      </AnimatePresence>
    </div>
  );
};

export default VendorManagement;
